import React from "react";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <div className="bg-[#fbfcff]">
        <div className="flex flex-col justify-center">
          <div
            className="mx-8 ml-10 mt-6 flex cursor-pointer flex-row items-center gap-1 text-sm font-medium text-gray-400 hover:text-sky-700"
            onClick={goBack}
          >
            <MdOutlineKeyboardBackspace size={20} />
            <div data-testid="back-btn">back to previous page</div>
          </div>
          <div className="mx-8 my-3 mt-[] flex flex-row items-center justify-between rounded-xl border border-gray-400 bg-white p-6">
            <div className="text-md flex flex-col font-semibold text-gray-800">
              <label className="fheader-label fheader-title mr-8 min-w-full">
                Something went wrong.{" "}
              </label>
              <label
                data-testid="error-text"
                className="mt-2 text-sm text-gray-400"
              >
                Please go back, and try again.
              </label>
            </div>
          </div>
        </div>
      </div>
    </React.Suspense>
  );
};

export default ErrorPage;
